export default __webpack_public_path__ + "static/media/Tracy Han.79f20a86.png";